import { render, staticRenderFns } from "./MoreModelActions.vue?vue&type=template&id=51f49e68"
import script from "./MoreModelActions.vue?vue&type=script&lang=ts"
export * from "./MoreModelActions.vue?vue&type=script&lang=ts"
import style0 from "./MoreModelActions.vue?vue&type=style&index=0&id=51f49e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports